import {
    pendingPlanRouteName,
} from "@/student/constants/routes";

import Store from "../store/store.js";

export default function navigationGuard({ to, next }) {

    const user = Store.state.auth.user;
    
    if(user && user.school.pending_plan_change && to.name != pendingPlanRouteName){
       next({ name:  pendingPlanRouteName });
       return;
    }else{
        next();
    }

}